import { Mixpanel } from 'mixpanel-browser'
import * as React from 'react'

import { MixpanelConsumer } from 'react-mixpanel'

export interface IMixpanelProps {
  mixpanel: Mixpanel
}

export const withMixpanel = <P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P & IMixpanelProps> => (props: P) => {
  return (
    <MixpanelConsumer>
      {mixpanel => <Component {...props} mixpanel={mixpanel} />}
    </MixpanelConsumer>
  )
}



// WEBPACK FOOTER //
// ./src/components/MixPanel/withMixpanel.tsx